export default "__VITE_ASSET__81864a57__"